const API_URL = process.env.REACT_APP_BACKEND_URL;

function getToken() {
  return localStorage.getItem('ivypro_token');
}

async function request(path, options = {}) {
  const token = getToken();
  const res = await fetch(`${API_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: 'Request failed' }));
    throw new Error(err.detail || 'Request failed');
  }
  return res.json();
}

export const lawApi = {
  // Dashboard
  getDashboard: () => request('/api/law/dashboard'),

  // Profile
  getProfile: () => request('/api/law/profile'),
  updateProfile: (data) => request('/api/law/profile', { method: 'PUT', body: JSON.stringify(data) }),

  // Schools
  getSchools: () => request('/api/law/schools'),
  createSchool: (data) => request('/api/law/schools', { method: 'POST', body: JSON.stringify(data) }),
  updateSchool: (id, data) => request(`/api/law/schools/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteSchool: (id) => request(`/api/law/schools/${id}`, { method: 'DELETE' }),

  // Applications
  getApplications: () => request('/api/law/applications'),
  updateApplication: (id, data) => request(`/api/law/applications/${id}`, { method: 'PUT', body: JSON.stringify(data) }),

  // Essays
  getEssays: () => request('/api/law/essays'),
  createEssay: (data) => request('/api/law/essays', { method: 'POST', body: JSON.stringify(data) }),
  updateEssay: (id, data) => request(`/api/law/essays/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteEssay: (id) => request(`/api/law/essays/${id}`, { method: 'DELETE' }),
};
